import Vue from 'vue'

// Lib imports
import axios from 'axios'
axios.defaults.headers.common['Auth-Token'] = 'foo bar';
Vue.prototype.$http = axios
